<template>
  <div class="steps">
    <div
      v-if="$route.name !== 'co.v2.template' && $route.name !== 'co.v2.chooseteam'"
      class="step"
      :class="{ active: $route.name === 'co.v2.create' || $route.name === 'co.v2.place' || $route.name === 'co.v2.summary' || $route.name === 'co.v2.success' }"
    >
      <div class="rond" :class="{ ellipsis: $route.name === 'co.v2.create' }"><span/><span/><span/></div>
      <p v-if="$route.name === 'co.v2.create'">Description mission</p>
      <el-tooltip
        v-if="$route.name !== 'co.v2.create' && fullTemplateName.length > 30"
        effect="dark"
        placement="top"
        :content="$route.name !== 'co.v2.create' ? fullTemplateName : ''"
        :show-after="300"
        :show-arrow="false"
      >
        <p class="item" @click="$router.push('/checkout/v2/create')">{{ currentTemplateName }}</p>
      </el-tooltip>
      <p
        v-if="$route.name !== 'co.v2.create' && fullTemplateName.length <= 30"
        @click="$router.push('/checkout/v2/create')"
      >{{ currentTemplateName }}</p>
    </div>
    <div
      v-if="$route.name !== 'co.v2.template' && $route.name !== 'co.v2.chooseteam'"
      class="step"
      :class="{ active: $route.name === 'co.v2.place' || $route.name === 'co.v2.summary' || $route.name === 'co.v2.success' }"
    >
      <div class="rond" :class="{ ellipsis: $route.name === 'co.v2.place' }"><span/><span/><span/></div>
      <p id="to-place-slots" @click="routerGo('/checkout/v2/place-and-slots')">
        {{
          $route.name === 'co.v2.create' || $route.name === 'co.v2.place' ? 'Lieux et créneaux' : countPlaces + countSlots
        }}</p>
    </div>
    <div
      v-if="$route.name !== 'co.v2.template' && $route.name !== 'co.v2.chooseteam'"
      class="step"
      :class="{ active: $route.name === 'co.v2.summary' || $route.name === 'co.v2.success' }"
    >
      <div class="rond" :class="{ ellipsis: $route.name === 'co.v2.summary' }"><span/><span/><span/></div>
      <p>{{ $route.name !== 'co.v2.success' ? 'Récapitulatif' : currentPrice }}</p>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useCheckoutV2Store } from '@/stores/checkoutv2';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapStores(useCheckoutV2Store),
    fullTemplateName() {
      const template = this.checkoutv2Store.lastSelectedTemplate;
      return template ? template.label : '';
    },
    currentTemplateName() {
      const name = this.fullTemplateName;
      return name.length <= 30 ? name : `${name.substring(0, 29)}...`;
    },
    countPlaces() {
      const nbrPlaces = this.checkoutv2Store.lastPlaceInfos ? this.checkoutv2Store.lastPlaceInfos.addresses.length : 1;
      return nbrPlaces === 1 ? `${nbrPlaces} Lieu` : `${nbrPlaces} Lieux`;
    },
    countSlots() {
      const places = this.checkoutv2Store.lastPlaceInfos ? this.checkoutv2Store.lastPlaceInfos.addresses : [];
      const countSlot = places.reduce((acc, item) => acc + item.slots.length, 0);
      return countSlot === 1 ? ` ${countSlot} Créneau` : ` ${countSlot} Créneaux`;
    },
    currentPrice() {
      // lastPricing stays null when the checkout store was not filled by the
      // previous steps (page reload or direct hit on the success step).
      const { lastPricing } = this.checkoutv2Store;
      return lastPricing ? `${lastPricing.total_without_vat} €` : 'Récapitulatif';
    },
  },
  methods: {
    routerGo(link) {
      if (this.$route.name !== 'co.v2.create') {
        this.$router.push(link);
      }
    },
  },
};
</script>
